<template>
    <import-notice-common-new isEdit></import-notice-common-new>
</template>
<script>
import importNoticeCommonNew from './importNoticeCommonNew.vue';

export default {
    name: 'importNoticeEdit',
    components: {
        importNoticeCommonNew,
    },
};
</script>
